import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { updateProductRecommendation } from '../../../views/market-comparison/market-comparison.actions';
import BusinessCaseProductView from './business-case-product.presenter';

// Map & Connect
export const mapStateToProps = state => ({
  productRecommendation: state.marketComparisonReducer.productRecommendation,
  cidn: state.dataBootStrapReducer.authentication.cidn,
  authorableContent: state.authorableContentReducer.authorableContent.marketComparison,
});

export const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({ updateProductRecommendation }, dispatch),
});

const BusinessCaseProduct = connect(
  mapStateToProps,
  mapDispatchToProps,
)(BusinessCaseProductView);

export default BusinessCaseProduct;
